"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorPage = void 0;
const react_1 = __importStar(require("react"));
const router_1 = require("next/dist/client/router");
const monera_app_core_1 = require("@amzn/monera-app-core");
const status_code_1 = require("@amzn/monera-app-core/lib/middleware/status-code");
const auth_1 = require("@amzn/monera-app-core/lib/utils/auth");
const metric_helper_1 = require("@amzn/monera-app-core/lib/utils/metric-helper");
const aws_rum_provider_1 = require("../components/aws-rum-provider");
const ErrorPage = ({ statusCode, error }) => {
    const [configStoreState] = (0, monera_app_core_1.useConfigStore)();
    const [shoppingPortalState] = (0, monera_app_core_1.useShoppingPortalStore)();
    const router = (0, router_1.useRouter)();
    const rumRecordError = (0, aws_rum_provider_1.useRumRecordError)();
    const rumRecordEvent = (0, aws_rum_provider_1.useRumRecordEvent)();
    const { asin, routing, tenant, countryCode } = configStoreState;
    monera_app_core_1.serverConsole.log(`Error page rendered, statusCode: ${statusCode}`, {
        asin,
        routing,
        router,
        tenant
    });
    rumRecordError(error);
    rumRecordEvent('error_page_render', {
        error: {
            name: error === null || error === void 0 ? void 0 : error.name,
            message: error === null || error === void 0 ? void 0 : error.message
        },
        statusCode,
        asin,
        ecid: shoppingPortalState.customerId,
        ubid: shoppingPortalState.ubid,
        deviceAttributes: shoppingPortalState.deviceAttributes,
        internalIpClass: shoppingPortalState.internalIpClass,
        query: router === null || router === void 0 ? void 0 : router.query
    });
    (0, react_1.useEffect)(() => {
        const tenant = window.moneraTenant;
        if (statusCode) {
            (0, metric_helper_1.meterStatusCode)({ statusCode, tenant, methodName: 'Home', requestId: configStoreState.requestId });
        }
    });
    (0, react_1.useEffect)(() => {
        if (statusCode === 401) {
            (0, auth_1.redirectToAuthPortalV2)(countryCode);
        }
        else {
            const statusCodeStr = statusCode || 'XXX';
            let fault = true;
            let error = false;
            if (statusCode >= 400 && statusCode < 500) {
                fault = false;
                error = true;
            }
            (0, metric_helper_1.meterFatals)({
                methodName: 'ErrorPage',
                metricName: `ErrorPage:${statusCodeStr}:${shoppingPortalState.deviceType}`,
                error,
                fault,
                requestId: '',
                tenant
            });
            (0, monera_app_core_1.showDoggyPageClientSide)();
        }
    }, []);
    return (0, metric_helper_1.isInternal)(shoppingPortalState.internalIpClass || '') ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("pre", null,
            "error: ",
            JSON.stringify(error, null, 2)),
        react_1.default.createElement("pre", null,
            "configStore: ",
            JSON.stringify(configStoreState, null, 2)),
        react_1.default.createElement("pre", null,
            "shoppingPortalStore: ",
            JSON.stringify(shoppingPortalState, null, 2)))) : (react_1.default.createElement(react_1.default.Fragment, null));
};
exports.ErrorPage = ErrorPage;
exports.ErrorPage.getInitialProps = ({ res, err }) => {
    var _a, _b;
    let statusCode = (_b = (_a = res === null || res === void 0 ? void 0 : res.statusCode) !== null && _a !== void 0 ? _a : err === null || err === void 0 ? void 0 : err.statusCode) !== null && _b !== void 0 ? _b : 500;
    if (!status_code_1.DOGGY_PAGE_STATUS_CODES.includes(statusCode.toString())) {
        statusCode = 500;
    }
    return {
        statusCode,
        error: err
    };
};
